import axios from '@helper/Api/api';

const getTransactionListApi = (accountId, query) => axios.get(`/api/v1/odata/accounts/${accountId}/synchronizations${query}`, { headers: { authorization: 'Bearer ' + localStorage.getItem('token') } }).then(result => result.data)
const getSyncListApi = (synchronizationId, query) => axios.get(`/api/v1/odata/accounts/synchronizations/${synchronizationId}${query}`, { headers: { authorization: 'Bearer ' + localStorage.getItem('token') } }).then(result => result.data)

export {
  getTransactionListApi,
  getSyncListApi
}